import { isMobile } from "react-device-detect";

export const redirectToPwa = () => {
  try {
    const pwaBaseUrl = process.env.PWA_BASE_URL;
    if (!pwaBaseUrl || !isMobile) return;

    const params = new URLSearchParams(window.location.search);
    const isLiteApp =
      window.location.host === "lite.unifize.com" || params.get("authCode");
    if (isLiteApp) return;

    const target = new URL(pwaBaseUrl);
    if (window.location.host === target.host) return;

    window.location.replace(
      `${pwaBaseUrl}${window.location.pathname}${window.location.search}${window.location.hash}`,
    );
  } catch (error) {
    console.error("Failed to redirect to PWA:", error);
  }
};
